// 发票添加编辑页埋点配置
const config = {
  // 发票填写
  'Invoice.detail.input': {
    operation: ['VISIBLE'],
    title: '发票填写',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type === 'person' ? 'personalinvoice_input' : 'corporateinvoice_input';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票是否默认状态
  'Invoice.detail.default': {
    operation: ['TOUCH'],
    title: '发票修改默认状态',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type === 'person' ? 'makeintodefault_personalinvoice' : 'makeintodefault_corporateinvoice';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ status }) => {
        return `status=${status}`;
      },
    },
  },
  // 发票删除
  'Invoice.detail.delete': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票删除',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type === 'person' ? 'delete_personalinvoice' : 'delete_corporateinvoice';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票保存
  'Invoice.detail.save': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票保存',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type === 'person' ? 'save_personalinvoice' : 'save_corporateinvoice';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票删除确认弹窗
  'Invoice.detail.delete.popup': {
    operation: ['VISIBLE'],
    title: '发票删除确认弹窗',
    c: {
      type: 'constant',
      value: 'delete_invoicetittle_pop',
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票删除确认弹窗
  'Invoice.detail.delete.confirm': {
    operation: ['TOUCH'],
    title: '发票删除弹窗确认',
    c: {
      type: 'constant',
      value: 'delete_check',
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票删除弹窗取消
  'Invoice.detail.delete.cancel': {
    operation: ['TOUCH'],
    title: '发票删除弹窗取消',
    c: {
      type: 'constant',
      value: 'delete_cancel',
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
};
export default config;
